<template>
    <div v-if="store.cards.length > 0">
        <div class="icon-wrapper" @click="toggleList">
            🔔
            <span class="badge" v-if="store.unreadCount > 0">
                {{ store.unreadCount }}
            </span>
        </div>
        <div class="dropdown" v-if="showList">
            <NotificationList
            :notifications="store.cards"
            @update="handleMarkAsRead"
            />
            <div ref="el"></div>
        </div>
    </div>
</template>
<script setup>
    import { ref , useTemplateRef } from 'vue'
    import { useInfiniteScroll } from '@vueuse/core'
    import { polling } from '@/composables/polling'
    import { isDefrentNotificationData } from '@/composables/polling/isDefrentNotificationData'
    import NotificationList from '@/components/tooles/nav/NotificationList.vue'
    import { useAlertStore } from '@/stores/alert'
    import { useNotificationStore } from '@/stores/notification'
    const store = useNotificationStore()
    const alertStore = useAlertStore()
    const showList = ref(false)
    const el = useTemplateRef('el')
    const isTabActive = ref(true)
    document.addEventListener('visibilitychange', () => {
        isTabActive.value = !document.hidden
    })
    function handleMarkAsRead(id) {
        store.markAsRead(id)
    }
    function toggleList() {
        showList.value = !showList.value
        store.requestAllowNotification()
    }
    polling( 
        async () => await store.fetchNotifications(store.cards.length > 0 ? store.cards.length : 10 , 0 , false),
        {
        oldData:store.cards??[],
        intervalMs: 6000,
        isDifferent: (newData) => isDefrentNotificationData(store.cards,newData),
        onChange: (allNewNotification) => {
            if(isDefrentNotificationData(store.cards??[],allNewNotification??[])){
                if(store.cards.length < allNewNotification.length){
                    alertStore.type=true
                    alertStore.msg='پیام سیستمی جدید رسید!'          
                    if (!isTabActive.value) {
                        store.callNotification(
                            'پیام جدید',
                            'یک پیام سیستمی جدید دریافت کردید'
                        )
                    }                    
                }
                store.cards = allNewNotification??[]
            }
        }
        }
    )
    useInfiniteScroll(
        el, 
        async () => {
        await store.fetchNotifications(10,store.cards.length,true) 
        } , { 
            distance: 50,
            canLoadMore: () => { 
                return store.hasMore
            }
        }
    )
</script>
<style scoped>
    .icon-wrapper {
        font-size: 24px;
        cursor: pointer;
        position: relative;
    }
    .badge {
        position: absolute;
        top: -6px;
        right: -10px;
        background-color: red;
        color: white;
        border-radius: 50%;
        padding: 2px 6px;
        font-size: 12px;
    }
    .dropdown {
        position: fixed;
        top: 60px;
        left: 0;
        width: 300px;
        background: white;
        border-radius: 10px;
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
    }
</style>